import {
  showErrorToast,
  showSuccessToast,
} from "components/CustomAlerts/CustomToast";
import { Input } from "components/Input/Input";
import { useFormik } from "formik";
import { OrganismoI } from "interfaces/Organismo";
import { TituloI } from "interfaces/Titulo";
import { useEffect } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { createTitulosSchema } from "schemas/titulos/createTitulosSchema";
import { postOrganismo, putOrganismo } from "services/organismos";
import { postTitulo, putTitulo } from "services/titulos";
import { RootState } from "store/store";

interface Props {
  actionType: "create" | "edit" | undefined;
  onClose?: any;
  elemento?: OrganismoI;
  onSuccess?: (organismo: OrganismoI) => void;
  showModal: boolean;
}

interface initialValues {
  id?: string | number;
  nombre: string;
  abreviatura: string;
  descripcion?: string;
}

export const OrganismosABM = ({
  showModal,
  actionType,
  onClose,
  elemento,
  onSuccess,
}: Props) => {
  const isEditMode = actionType == "edit";
  const initialValues: initialValues = {
    nombre: "",
    abreviatura: "",
    descripcion: "",
  };

  const renderInitialValues = async () => {
    let currentValues;

    if (isEditMode && elemento) {
      currentValues = {
        id: elemento?.id ?? "",
        nombre: elemento?.nombre ?? "",
        abreviatura: elemento?.abreviatura ?? "",
        descripcion: elemento?.descripcion ?? "",
      };
    } else {
      currentValues = initialValues;
    }
    setValues(currentValues);
  };

  const handleSubmitCreate = async (params: any) => {
    try {
      // const p = { nombre: params.nombre, }
      const newOrganismo = await postOrganismo({ params });
      showSuccessToast("¡El organismo fue creado con éxito!");
      if (onSuccess) onSuccess(newOrganismo);
      onClose();
    } catch (err: any) {
      showErrorToast("El organismo no pudo ser creado.");
      console.log(err.message);
    }
  };

  const handleSubmitEdit = async (params: any) => {
    try {
      const newTitulo = await putOrganismo({ params })
      showSuccessToast("¡El organismo fue editado con éxito!");
      if (onSuccess) onSuccess(newTitulo)
      onClose()
    } catch (err: any) {
      showErrorToast("El organismo no pudo ser creado.");
      console.log(err.message);
    }
  };

  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    isSubmitting,
    handleSubmit,
    setValues,
  } = useFormik({
    initialValues,
    // validationSchema: createTitulosSchema,
    onSubmit: actionType == "create" ? handleSubmitCreate : handleSubmitEdit,
  });

  const { loadingAppData, tiposNormativa } = useSelector(
    (st: RootState) => st.appData,
  );

  useEffect(() => {
    if (actionType) {
      renderInitialValues();
    }
  }, [actionType]);

  return (
    <>
      <Modal show={showModal} onHide={onClose} size="lg" centered>
        <Modal.Header>
          <Modal.Title>
            {isEditMode ? "Editar Organismo" : "Nuevo Organismo"}
          </Modal.Title>
        </Modal.Header>
        <form onSubmit={handleSubmit}>
          <Modal.Body>
            <Col>
              <Row>
                <Col sm={6} className="mb-3">
                  <Input
                    id={"nombre"}
                    title="Nombre del organismo"
                    required
                    onChange={handleChange}
                    onBlur={handleBlur}
                    values={values}
                    errors={errors}
                    touched={touched}
                    variant="gray-container"
                    size="lg"
                  />
                </Col>
                <Col sm={6} className="mb-3">
                  <Input
                    id={"abreviatura"}
                    title="Abreviatura del organismo"
                    required
                    onChange={handleChange}
                    onBlur={handleBlur}
                    values={values}
                    errors={errors}
                    touched={touched}
                    variant="gray-container"
                    size="lg"
                  />
                </Col>
                <Col sm={12}>
                  <Input
                    id={"descripcion"}
                    title="Descripción"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    values={values}
                    errors={errors}
                    touched={touched}
                    variant="gray-container"
                    size="lg"
                  />
                </Col>
              </Row>
            </Col>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="mx-3"
              variant="secondary"
              size="lg"
              onClick={onClose}
            >
              Cancelar
            </Button>
            <Button
              variant="primary"
              size="lg"
              className="user-submit-button"
              /* disabled={isSubmitting} */ type="submit"
            >
              {isEditMode ? "Guardar Cambios" : "Confirmar"}
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
};
